import lottie, { AnimationItem } from 'lottie-web';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './index.scss';

const Lottie = forwardRef((props: any, ref: any) => {
  // let animation:AnimationItem;
  const [animation, setAnimation] = useState<AnimationItem>(null);
  const lottieRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setAnimation(
      lottie.loadAnimation({
        container: lottieRef.current as HTMLInputElement,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: props.url
      })
    );
  }, []);
  useEffect(() => {
    if (animation) {
      const play: boolean = props.play;
      if (play) {
        animation?.play();
      }
    }
  }, [animation]);
  useImperativeHandle(ref, () => ({
    pauseAnimation() {
      animation?.pause();
    },
    playAnimation() {
      animation?.play();
    },
    stopAnimation() {
      animation?.stop();
    },
    goToAndStop(time: number) {
      animation?.goToAndStop(time);
    },
    goToAndPlay(time: number) {
      animation?.goToAndPlay(time);
    }
  }));
  return <div className='lottie-con' ref={lottieRef}></div>;
});

export default Lottie;
